export const LABEL_OFFSET_CORNER_SIGN = 2;
